import { css } from '@emotion/react';
import React from 'react';

import { BasicTableColumn, ColumnType, NvBasicTable } from 'shared/components/nv-basic-table';
import LoadingWrapper, { LoaderType } from 'shared/components/loading-wrapper';
import LoadingPlaceholder from 'shared/components/loading-placeholder';

export type UserListEntry = {
  id: number;
  fullName: string;
  email: string;
};

// NvBasicTable's types are incorrect (expects T but needs Record<id, T> at runtime).
// TODO : Fix NvBasicTable types and remove the UserListBasicTable wrapper.
// This wrapper provides correct types for UserListEntry usage.
type UserListBasicTableProps = {
  columns: BasicTableColumn[];
  tabledata: Record<number, UserListEntry>;
  rowComponent: React.ComponentType<UserListEntry>;
  rowClass: string;
  showHeader: boolean;
  highlightClass: string;
};
const UserListBasicTable = NvBasicTable as unknown as React.ComponentType<UserListBasicTableProps>;

type UserListModalBodyProps = {
  title: string;
  subtitle?: string;
  countLabel: string;
  users: Record<number, UserListEntry>;
  isLoaded: boolean;
  isPageFetching: boolean;
  userTableRef: React.RefObject<HTMLDivElement>;
  downloadAction?: React.ReactNode;
};

const NameRow = ({ fullName, email }: UserListEntry) => (
  <React.Fragment>
    <div className='text-regular'>{fullName}</div>
    <div className='text-regular'>{email}</div>
  </React.Fragment>
);

const cols: BasicTableColumn[] = [
  {
    key: 'fullName',
    name: '',
    className: 'column',
    sortable: false,
    gridWidth: '60%',
    type: ColumnType.STRING,
  },
  {
    key: 'email',
    name: '',
    className: 'column',
    sortable: false,
    gridWidth: '40%',
    type: ColumnType.STRING,
  },
];

const styles = css`
  .disabled {
    opacity: 0.4;
  }
  .user-table {
    height: 520px;
    overflow-y: auto;
  }
  .basic-table {
    margin-top: 0px !important;
  }
`;

const UserListModalBody = ({
  title,
  subtitle,
  countLabel,
  users,
  isLoaded,
  isPageFetching,
  userTableRef,
  downloadAction,
}: UserListModalBodyProps) => (
  <div
    className='d-flex flex-column px-7 mt-4 mb-6'
    css={styles}
  >
    <div className='text-large-regular font-weight-bolder'>
      {title}
    </div>
    {subtitle && (
      <div className='text-date'>{subtitle}</div>
    )}
    <div className='d-flex font-weight-bolder mb-4'>
      <div className='text-regular'>{countLabel}</div>
      {downloadAction}
    </div>
    <div ref={userTableRef} className='user-table pb-2'>
      <LoadingWrapper
        loaderType={LoaderType.PLACEHOLDER}
        isLoaded={isLoaded}
        className='w-100 mt-5'
      >
        <UserListBasicTable
          columns={cols}
          tabledata={users}
          rowComponent={NameRow}
          rowClass='p-3'
          showHeader={false}
          highlightClass=''
        />
        {isPageFetching && <LoadingPlaceholder />}
      </LoadingWrapper>
    </div>
  </div>
);

export default UserListModalBody;
